import * as React from 'react';
import Comment from './sub/comment';
import Link from './sub/link';
import MainMedia from './sub/main-media';
import { NativeAdObj } from '../../shared/types/ast';
import Logo from './sub/logo';
import Title from './sub/title';
import TransparencyButton from './sub/transparencyButton';
import Description from './sub/description';
import Badge from './sub/badge';
import useSize from '../hooks/size';

type Props = {
    adObj: NativeAdObj;
    list?: boolean;
};

export default function Content(props: Props) {
    const {
        adObj,
        adObj: { native },
        list = false,
    } = props;

    const [ref, size] = useSize();
    return (
        <React.Fragment>
            <Comment placement="Content" adObj={adObj} />
            <Link
                adObj={adObj}
                className="u-mv8"
                style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: list ? 'row' : 'column',
                    textAlign: 'left',
                    color: '#474445',
                    backgroundColor: '#F6F8FB',
                    textDecoration: 'none',
                    borderRadius: '8px',
                }}
                ref={ref}
            >
                <div
                    style={{
                        flex: '1 1 30%',
                        display: 'flex',
                        padding: list ? '8px 2px 8px 8px' : '0',
                    }}
                >
                    <MainMedia
                        native={native}
                        style={{
                            borderRadius: list ? '8px' : '8px 8px 0 0',
                            objectFit: 'cover',
                            width: '100%',
                            height: '100%',
                        }}
                    />
                </div>
                <div
                    style={{
                        flex: '1 1 70%',
                        display: 'flex',
                        flexDirection: 'column',
                        padding:
                            size === 'large' ? '16px' : '8px 16px 16px 16px',
                    }}
                >
                    <div
                        className="u-d1"
                        style={{
                            display: 'flex',
                            marginBottom: list ? '16px' : '8px',
                            color: '#767676',
                        }}
                    >
                        <Badge native={native} />
                        <TransparencyButton
                            adObj={adObj}
                            style={{
                                width: '18px',
                                height: '18px',
                                position: 'relative',
                                marginLeft: 'auto',
                                zIndex: 1,
                                opacity: 0.6,
                            }}
                        />
                    </div>

                    {size === 'small' && (
                        <Title native={native} className="u-b1" />
                    )}

                    <div
                        style={{
                            flex: '1 0 auto',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                        }}
                    >
                        <div
                            style={{
                                flex: '0 1 auto',
                            }}
                        >
                            {size !== 'small' && (
                                <Title
                                    native={native}
                                    className={
                                        size === 'large' ? 'u-t3' : 'u-b1'
                                    }
                                />
                            )}

                            <Description
                                native={native}
                                className={
                                    size === 'large' ? 'u-caption' : 'u-d1'
                                }
                            />
                        </div>
                        <Logo
                            native={native}
                            style={{
                                height: 'auto',
                                flex: '0 1 auto',
                                maxHeight: '48px',
                                maxWidth: '20%',
                                alignSelf: 'flex-end',
                            }}
                        />
                    </div>
                </div>
            </Link>
        </React.Fragment>
    );
}
